import React from 'react';
import type { LogoMakerIntegration } from '../../context/LogoMakerContext';
import LogoMakerProviders from '../../context/LogoMakerContext/LogoMakerProviders';
import { LoggedOutLogoMaker } from '../LoggedOutLogoMaker/LoggedOutLogoMaker';

export interface ModernLoggedOutLogoMakerLPProps {
    showBackButton?: boolean;
    integration?: LogoMakerIntegration;
}

export const ModernLoggedOutLogoMakerLP = ({ showBackButton, integration }: ModernLoggedOutLogoMakerLPProps = {}) => (
    <LogoMakerProviders isSticky isTransparent showBackButton={showBackButton} integration={integration}>
        <LoggedOutLogoMaker showSeoLinks showJoinLink />
    </LogoMakerProviders>
);

export default ModernLoggedOutLogoMakerLP;
